import { Add01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { ButtonBase, CardMedia, IconButton, useTheme } from '@mui/material';
import './DishCard.scss';

interface DishCardProps {
  title: string;
  previewDescription: string;
  description: string;
  price: string;
  image?: string;
  onClick?: () => void;
}

const DishCard = ({
  title,
  previewDescription,
  description,
  price,
  image,
  onClick,
}: DishCardProps) => {
  const theme = useTheme();

  return (
    <ButtonBase
      className="dish dish--catalog-card"
      onClick={onClick}
      component="div"
      sx={{ alignItems: 'flex-start' }}
    >
      {image ? (
        <CardMedia
          className="dish__image"
          component={'img'}
          title={title}
          image={image}
        />
      ) : null}

      <div className="dish__body">
        <div className="dish__body-header">
          <h3 className="dish__title">{title}</h3>
          <p className="dish__price">{price}</p>
        </div>
        <p className="dish__description">{previewDescription ?? description}</p>

        <div className="dish__actions">
          <IconButton
            className="dish__btn-details"
            size="small"
            onClick={onClick}
            sx={{
              backgroundColor: theme.palette.primary.main,
            }}
          >
            <HugeiconsIcon icon={Add01Icon} className="dish__btn-icon" color="white" />
          </IconButton>
        </div>
      </div>
    </ButtonBase>
  );
};

export default DishCard;
